import { useEffect } from "react";
const SESSION_MARKER_KEY = "session_marker";

export const useSessionStorageSync = () => {
  useEffect(() => {
    // Check for active tab session marker
    const hasSession = sessionStorage.getItem(SESSION_MARKER_KEY);

    if (!hasSession) {
      // No session marker => new browser tab or reopened session
      console.info("🔒 New browser session detected — clearing localStorage.");
 
      localStorage.clear();
    }

    // Establish a marker for this active tab session
    sessionStorage.setItem(SESSION_MARKER_KEY, "active");
  }, []);
};
